import { render, staticRenderFns } from "./EditLabelModal.vue?vue&type=template&id=57e1be17&scoped=true"
import script from "./EditLabelModal.vue?vue&type=script&lang=js"
export * from "./EditLabelModal.vue?vue&type=script&lang=js"
import style0 from "./EditLabelModal.vue?vue&type=style&index=0&id=57e1be17&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1be17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e1be17')) {
      api.createRecord('57e1be17', component.options)
    } else {
      api.reload('57e1be17', component.options)
    }
    module.hot.accept("./EditLabelModal.vue?vue&type=template&id=57e1be17&scoped=true", function () {
      api.rerender('57e1be17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/productAppConfig/productConfig/projectManage/components/EditLabelModal.vue"
export default component.exports